import * as React from "react"
import { JSX } from "react/jsx-runtime"

export function UserCircle(props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={42}
      height={42}
      viewBox="0 0 42 42"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8.962 31.157A24.388 24.388 0 0121 28c4.375 0 8.483 1.147 12.038 3.157M26.25 17.5a5.25 5.25 0 11-10.5 0 5.25 5.25 0 0110.5 0zm10.5 3.5c0 8.698-7.052 15.75-15.75 15.75S5.25 29.698 5.25 21 12.302 5.25 21 5.25 36.75 12.302 36.75 21z"
        stroke={props.color}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

